import { render, staticRenderFns } from "./RoomSchedulePage.vue?vue&type=template&id=645c16fe&scoped=true"
import script from "./RoomSchedulePage.vue?vue&type=script&lang=js"
export * from "./RoomSchedulePage.vue?vue&type=script&lang=js"
import style0 from "./RoomSchedulePage.vue?vue&type=style&index=0&id=645c16fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c16fe",
  null
  
)

export default component.exports